import { formatDistanceToNow, parseISO } from 'date-fns';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'relativeTime',
	standalone: true,
})
export class RelativeTimePipe implements PipeTransform {
	transform(timestamp: string): string {
		if (!timestamp) return '';

		try {
			return formatDistanceToNow(parseISO(timestamp), { addSuffix: true });
		} catch (error) {
			console.error('Invalid timestamp:', timestamp);
			return 'Invalid date';
		}
	}
}
